import preval from "preval.macro";

const info = {
  time: preval`module.exports = new Date().toISOString()`,
  branch: preval`module.exports = require('child_process').execSync('git rev-parse --abbrev-ref HEAD').toString().trim()`,
  commit: preval`module.exports = require('child_process').execSync('git rev-parse HEAD').toString().trim()`,
};

window.BUILD_INFO_WEB2_UTILS = info;
